module.exports = __webpack_public_path__ + "static/blackcherry-e95ce052a2cf28d26fdded3b4e1e8494.jpg";